

<template>
  <div class="cashback-offer aside-item">
    <div class="aside-item-title">{{ $t('Лучшие предложения по кэшбэку') }}</div>
    <div class="cashback-offer-image">
      <app-img :src="cashbackOffer.image || cashbackOffer.logo_url"></app-img>
    </div>
    <span class="cashback-title">{{ $t('Кэшбэк') }}</span>
    <span class="cashback-sum">{{ cashbackOffer.cashbe_value }} <span v-if="cashbackOffer.cashbe_type === 'fixed'">руб.</span><span v-else>%</span></span>
    <a class="button-secondary" :href="`/go/cashbe/${cashbackOffer.id}/authbuttonsidebar/`" target="_blank">{{ $t('Перейти в Cashbe') }}</a>
  </div>
</template>

<script>
import AppImg from '../AppImg.vue';

export default {
  name: 'shop-cashback-offer',

  components: {
    AppImg
  },

  props: {
    cashbackOffer: {
      type: Object,
      default: () => { return {} }
    }
  },

  data() {
    return {};
  },

  methods: {}
};
</script>

<style scoped>
.cashback-offer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cashback-offer-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 165px;
  height: 110px;
  margin: 12px 0;
}

.cashback-offer .cashback-title {
  font-size: 18px;
}

.cashback-offer .cashback-sum {
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: bold;
}
</style>
